import { serverApi } from '../api'


export const getUltimos = async() => {

    const codigoEntidad= localStorage.getItem('codigoEntidad') || null;
    const codigoUbicacion= localStorage.getItem('codigoUbicacion') || null;

    console.log("codigoEntidad");
    console.log(codigoEntidad);
    console.log(codigoUbicacion);
    

    if( codigoEntidad === null ) return [];

    try {
                    
        console.log("aca entro");
        
        const resp = await serverApi.get(`/tickets/ultimos/${codigoEntidad}/${codigoUbicacion}`);
        console.log(resp);
        const aten=  resp.data.ultimos;
        
        return (aten);
        
        
        
    } catch (error) {
        console.error("Error al obtener ubicaciones", error);
    }

  


}